export const columnsCsv = [
  { key: "createdDate", label: " Date" },
  { key: "identifier", label: "Card Serial Number" },
  { key: "lastFailedAttemptTimeStamp", label: "Last Failed Attempt Date" },
  
];
export const options = [
  { value: "Admin", label: "Admin" },
  { value: "Call Centre Agent", label: "Call Centre Agent" },
  { value: "Customer Service Agent", label: "Customer Service Agent" },
  { value: "Super Admin", label: "Super Admin" },
];
